import * as R from 'ramda';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import MatrixSet from 'components/general/MatrixSet/MatrixSet';
import { selectors } from './../ducks/page.duck';
import { selectors as treeSelectors } from './../ducks/tree.duck';

const getTitle = createSelector(
  selectors.data,
  R.prop('title'),
);

const getSummary = createSelector(
  selectors.data,
  R.prop('metaDescription'),
);

const getCategory = createSelector(
  selectors.data,
  treeSelectors.data,
  (current, tree) =>  {
    const id = R.prop('id', current);

    return R.tryCatch(
      R.pipe(
        R.prop('children'),
        R.find(R.pipe(
          R.prop('children'),
          R.find(R.propEq('id', id)),
        )),
      ),
      R.always(null),
    )(tree);
  },
);

const getContent = createSelector(
  selectors.data,
  R.pipe(
    R.path(['body', '0', 'blocks']),
    blocks => [{ blocks }],
  ),
);

const InfoContent = connect(R.applySpec({
  title: getTitle,
  summary: getSummary,
  category: getCategory,
  content: getContent,
  loading: selectors.loading,
}))(MatrixSet);

export default InfoContent;

